import { html, View } from 'rune-ts';
import { ELang } from '@services/MarppleShop/shared/enum/ELang.ts';
import { UtilS } from '@modules/Util/S/Function/module/UtilS';
import { font } from '@services/MarppleShop/shared/typography';
import { classes } from '@services/MarppleShop/shared/util';
import { CardProductError } from '@services/MarppleShop/shared/components/atoms/MarppleShopDesignSystem/CardProduct/CardProductView.ts';

export type TProps =
  | {
      size: '12px';
      price: number;
      price_en: number | null;
      price_jp: number | null;
    }
  | {
      size: '13px';
      price: number;
      price_en: number | null;
      price_jp: number | null;
    }
  | {
      size: '14px';
      price: number;
      price_en: number | null;
      price_jp: number | null;
    }
  | {
      size: '15px';
      price: number;
      price_en: number | null;
      price_jp: number | null;
    }
  | {
      size: '16px';
      price: number;
      price_en: number | null;
      price_jp: number | null;
    }
  | {
      size: '18px';
      price: number;
      price_en: number | null;
      price_jp: number | null;
    }
  | {
      size: '20px';
      price: number;
      price_en: number | null;
      price_jp: number | null;
    };

/**
 * https://www.figma.com/design/Top00pi5q5ylSxEviOOciV/MarppleShop-Design-System?node-id=26351-74853&m=dev
 */
export class PriceView extends View<TProps> {
  protected override template(props: TProps) {
    let local_price;
    if (ET.lang === ELang.Kr) {
      local_price = props.price;
    } else if (ET.lang === ELang.En) {
      local_price = props.price_en;
    } else if (ET.lang === ELang.Jp) {
      local_price = props.price_jp;
    } else {
      throw new CardProductError();
    }

    const commified_price = UtilS.commify(local_price);

    const currency_symbol = UtilS.getCurrency(ET.lang);

    const price_html =
      ET.lang === ELang.Kr
        ? html`<span>${commified_price}</span><span>${currency_symbol}</span>`
        : html`<span>${currency_symbol}</span><span>${commified_price}</span>`;

    if (props.size === '12px') {
      return html`<span class="${classes(font('12_semibold'), 'price-number')}">${price_html}</span>`;
    } else if (props.size === '13px') {
      return html`<span class="${classes(font('13_semibold'), 'price-number')}">${price_html}</span>`;
    } else if (props.size === '14px') {
      return html`<span class="${classes(font('14_semibold'), 'price-number')}">${price_html}</span>`;
    } else if (props.size === '15px') {
      return html`<span class="${classes(font('15_bold2'), 'price-number')}">${price_html}</span>`;
    } else if (props.size === '16px') {
      return html`<span class="${classes(font('16_bold'), 'price-number')}">${price_html}</span>`;
    } else if (props.size === '18px') {
      return html`<span class="${classes(font('18_bold'), 'price-number')}">${price_html}</span>`;
    } else if (props.size === '20px') {
      return html`<span class="${classes(font('20_bold'), 'price-number')}">${price_html}</span>`;
    } else {
      throw new CardProductError();
    }
  }
}
